(function () {
  const input   = document.getElementById('retailer-search');
  const btn     = document.getElementById('retailer-search-btn');
  const clear   = document.getElementById('retailer-search-clear');
  const noRes   = document.getElementById('retailer-no-results');
  const items   = document.querySelectorAll('.retailer-map__retailer');
  if (!input) return;

  function filter() {
    const q = input.value.trim().toLowerCase();
    let visible = 0;
    items.forEach(item => {
      const match = !q
        || item.dataset.name?.includes(q)
        || item.dataset.city?.includes(q)
        || item.dataset.province?.includes(q);
      item.classList.toggle('is-hidden', !match);
      if (match) visible++;
    });
    noRes.classList.toggle('hidden', visible > 0);
    clear.classList.toggle('hidden', !q);
  }

  btn.addEventListener('click', filter);
  input.addEventListener('keydown', e => { if (e.key === 'Enter') filter(); });
  clear.addEventListener('click', () => { input.value = ''; filter(); });
})();
